import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@crono-one/design-system';
import { ContactInfoIcon, ContactMethod } from 'components/ContactInfo';
import { getFieldPlaceholder } from 'components/CreationForms/utils/fields';
import { ReactNode } from 'react';

/** One contact method row of a form: its method, label and placeholder. */
export interface ContactMethodRow<M extends ContactMethod> {
  method: M;
  label: string;
  placeholder: string;
}

export interface ContactMethodFieldProps {
  /** The contact method (phone, email, LinkedIn, website…), shown as its icon. */
  method: ContactMethod;
  /** Accessible name of the input, e.g. "Email". */
  label: string;
  /** The field adds a star when the it's required and an ellipsis otherwise. */
  placeholder: string;
  required?: boolean;
  /** Shown at the end of the input. */
  endAddon?: ReactNode;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

/** A contact method of a record (phone, email, LinkedIn, website…): its icon, a borderless input and an optional action at its end. */
const ContactMethodField = ({
  method,
  label,
  placeholder,
  required,
  endAddon,
  disabled,
  value,
  onChange,
  onBlur,
}: ContactMethodFieldProps) => (
  <div className="flex items-center gap-2">
    <ContactInfoIcon method={method} />
    <InputGroup variant="ghost" dsSize="sm" className="flex-1">
      <InputGroupInput
        aria-label={label}
        placeholder={getFieldPlaceholder(placeholder, required)}
        disabled={disabled}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
      />
      {endAddon && (
        <InputGroupAddon align="inline-end">{endAddon}</InputGroupAddon>
      )}
    </InputGroup>
  </div>
);

export default ContactMethodField;
